export enum IBANStatus {
  REQUESTED = "requested",
  IN_PROGRESS = "in_progress",
  SETTLEMENT_READY = "settlement_ready",
  ACTIVE_SETTLEMENT = "active_settlement",
  REJECTED = "rejected",
  APPROVED = "approved",
}

export interface IBANItem {
  id: string;
  title: string;
  iban: string;
  status: IBANStatus;
  isActiveSettlement: boolean;
  errorMessage?: string;
}

export interface StatusInfo {
  color: string;
  text: string;
  icon: React.ReactNode;
}

export interface IBANItemRequest {
  iban: string;
  description: string;
}

export interface AddShaparakIbansRequest {
  ibans: IBANItemRequest[];
}

export interface RemoveShaparakIbansRequest {
  ibans: IBANItemRequest[];
}

export interface GetIbansQueryParams {
  PageNumber: number;
  PageSize: number;
}

export interface IBANItemResponse {
  iban: string;
  bankId: number;
  description: string;
  ibanType: number;
  userId: number;
  requestStatus: number;
  requestErrors: RequestError[];
}

export interface RequestError {
  id: number;
  codeExceptionValue: number;
  fieldName: string;
}

export interface GetIbansResponse {
  list: {
    items: IBANItemResponse[];
    pageNumber: number;
    totalPages: number;
    totalCount: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
  };
}

export interface ApiResult {
  succeeded: boolean;
  errors: {
    ipgType: number;
    name: string;
    error: string;
  }[];
  value: string;
}

export interface AddShaparakIbansResponse {
  result: ApiResult;
}

export interface RemoveShaparakIbansResponse {
  result: ApiResult;
}
